// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7) return "static/chunks/7-694f1e16c0798c75.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4095":"e1d471be66d95097","8241":"26b36837bd6c834a"}[chunkId] + ".js";
};